/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index tooltip to autogenerate all the components and extensions
 * Used by "prepareTooltips"
 */

import Tooltip from './tooltip/Tooltip'
export * from './tooltip/Tooltip'
export default Tooltip
